import React from 'react';

const PaymentPayPal = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="24"
      viewBox="0 0 32 24"
      fill="none"
    >
      <path
        d="M22.1134 7.58116C22.3287 6.17435 22.1134 5.23647 21.3597 4.37074C20.5343 3.39679 19.0269 3 17.0889 3H11.5262C11.1314 3 10.8084 3.28858 10.7366 3.68537L8.40382 18.4749C8.36793 18.7635 8.58326 19.016 8.87037 19.016H12.3157L12.0645 20.5311C12.0286 20.7836 12.208 21 12.4952 21H15.4022C15.7611 21 16.0482 20.7475 16.0841 20.4228L16.6942 16.5992C16.7301 16.2745 17.0531 16.022 17.3761 16.022H17.8067C20.6061 16.022 22.8312 14.8677 23.4772 11.5491C23.7284 10.1784 23.6207 8.98798 22.903 8.19439C22.6876 7.94188 22.4364 7.76152 22.1134 7.58116Z"
        fill="#009CDE"
      />
      <path
        d="M22.1134 7.58116C22.3287 6.17435 22.1134 5.23647 21.3597 4.37074C20.5343 3.39679 19.0269 3 17.0889 3H11.5262C11.1314 3 10.8084 3.28858 10.7366 3.68537L8.40382 18.4749C8.36793 18.7635 8.58326 19.016 8.87037 19.016H12.3157L13.1412 13.6774C13.2129 13.2806 13.5359 12.992 13.9307 12.992H15.5816C18.8116 12.992 21.3238 11.6934 22.0416 7.86974C22.0775 7.79759 22.0775 7.68938 22.1134 7.58116Z"
        fill="#012169"
      />
      <path
        d="M14.1102 7.61723C14.146 7.36473 14.469 7.04008 14.7921 7.04008H19.1705C19.6729 7.04008 20.1754 7.07615 20.6061 7.1483C21.0008 7.22044 21.7186 7.4008 22.0775 7.61723C22.2928 6.21042 22.0775 5.27254 21.3238 4.40681C20.5343 3.39679 19.0269 3 17.0889 3H11.5262C11.1314 3 10.8084 3.28858 10.7366 3.68537L8.40382 18.4749C8.36793 18.7635 8.58326 19.016 8.87037 19.016H12.3157L14.1102 7.61723Z"
        fill="#003087"
      />
    </svg>
  );
};

export default PaymentPayPal;
